import { gsap } from "gsap"
import { Flip } from "gsap/Flip"
import { refreshAllControllers } from "@/scripts/common/api/scrolltrigger.services"
gsap.registerPlugin(Flip)

const CLASS_PAGINATION_PRE = 'ui-pagination'
export const UIpagination = (() => {
    class Pagination {
        constructor(container, options) {
            this.$container = container
            this.$items = this.$container.querySelectorAll(`.${CLASS_PAGINATION_PRE}__item`)
            this.$loadmoreBtn = this.$container.querySelector(`.${CLASS_PAGINATION_PRE}__loadmore-action`)

            this.options = Object.assign(defaultPaginationOptions, options)
            this.limit = this.options.limit
            this.increment = this.options.increment
            this.totalItems = this.$items.length
            this.flipItemState = null
            this.flipPanelState = null

            this.init()
        }

        init() {
            this.updateUI()
            this.addListeners()
        }

        updateUI() {

            this.getFlipStates()
            this.showItems()
            this.showAction()
            this.flipAnimate()
        }

        showItems() {
            this.$items.forEach(($item, i) => {
                $item.style.display = (i >= this.limit) ? 'none' : 'block'
            })
        }

        showAction() {
            if (this.limit === this.totalItems) this.$loadmoreBtn.classList.add('d-none')
        }

        incLimit() {
            if (this.limit < this.totalItems) this.limit += this.increment
            if (this.limit > this.totalItems) this.limit = this.totalItems
        }

        // Get initial state
        getFlipStates() {
            this.flipItemState = Flip.getState(this.$items)
            this.flipPanelState = Flip.getState(this.$container)
        }

        // Animation
        flipAnimate() {
            const tl = gsap.timeline({
                onStart: () => this.$loadmoreBtn.classList.add('disabled'),
                onComplete: () => {
                    refreshAllControllers()
                    this.$loadmoreBtn.classList.remove('disabled')
                }
            })
            tl.add(Flip.from(this.flipItemState, {
                duration: 0.4,
                scale: false,
                ease: "power2.inOut",
                absolute: false,
                onEnter: elements => gsap.fromTo(elements, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.3, stagger: 0.1 }),
            }), 0)
                .add(Flip.from(this.flipPanelState, {
                    duration: 0.4,
                    scale: false,
                    ease: "power2.inOut",
                    absolute: false
                }), 0)

        }

        // Callbacks
        onLoadMoreClick(e) {
            e.preventDefault()
            this.incLimit()
            this.updateUI()
        }

        addListeners() {
            this.$loadmoreBtn.addEventListener('click', (e) => this.onLoadMoreClick(e))
        }
    }

    const defaultPaginationOptions = {
        limit: 5,
        increment: 5
    }

    return {
        Pagination
    }
})()